import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { Compass, Phone } from 'lucide-react';
import { BUSINESS } from '../config';

/**
 * Repli des routes publiques.
 *
 * Le `<Routes>` de `PublicShell` n'avait aucun repli : toute URL inconnue rendait un
 * en-tête, une zone vide et un pied de page. Un lien périmé, une faute de frappe ou
 * une URL de retour non déclarée aboutissaient donc au même écran muet, impossible à
 * distinguer d'une panne.
 */
export default function NotFound() {
  return (
    <div
      className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24 text-center"
      data-testid="not-found-page"
    >
      <Helmet>
        <title>{`Page introuvable — ${BUSINESS.name}`}</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <div className="w-16 h-16 rounded-full bg-secondary/15 flex items-center justify-center mx-auto mb-4">
        <Compass className="w-8 h-8 text-secondary" />
      </div>

      <h1 className="font-heading font-semibold text-2xl md:text-3xl text-primary uppercase tracking-tight mb-3">
        Page introuvable
      </h1>
      <p className="text-slate-700 mb-8">
        Cette adresse ne correspond à aucune page de la boutique. Le lien est
        peut-être périmé, ou l'article a quitté le catalogue.
      </p>

      <div className="flex flex-wrap items-center justify-center gap-4 mb-8">
        <Link
          to="/catalogue"
          className="bg-secondary text-black font-bold uppercase tracking-wider rounded-sm px-6 py-3 text-sm hover:opacity-90 transition-opacity"
          data-testid="not-found-catalogue"
        >
          Voir le catalogue
        </Link>
        <Link
          to="/"
          className="text-sm font-semibold text-slate-600 underline underline-offset-4 hover:text-secondary transition-colors"
          data-testid="not-found-accueil"
        >
          Retour à l'accueil
        </Link>
        <Link
          to="/contact"
          className="text-sm font-semibold text-slate-600 underline underline-offset-4 hover:text-secondary transition-colors"
          data-testid="not-found-contact"
        >
          Nous contacter
        </Link>
      </div>

      <a
        href={`tel:${BUSINESS.telephoneRaw}`}
        className="inline-flex items-center gap-2 text-sm font-semibold text-primary hover:text-secondary transition-colors"
        data-testid="not-found-telephone"
      >
        <Phone className="w-4 h-4" />
        {BUSINESS.telephone}
      </a>
    </div>
  );
}
